import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "container"
}
const _hoisted_2 = { class: "width_wrap" }
const _hoisted_3 = {
  key: 0,
  class: "body_content"
}
const _hoisted_4 = { class: "sub1" }
const _hoisted_5 = { class: "st_mybd_list" }
const _hoisted_6 = { rowspan: "3" }
const _hoisted_7 = { class: "sub1" }
const _hoisted_8 = { class: "st_mybd_list" }
const _hoisted_9 = { rowspan: "3" }
const _hoisted_10 = { class: "sub1" }
const _hoisted_11 = { class: "st_mybd_list" }
const _hoisted_12 = { rowspan: "3" }
const _hoisted_13 = { class: "sub1" }
const _hoisted_14 = { class: "st_mybd_list" }
const _hoisted_15 = { rowspan: "3" }
const _hoisted_16 = { class: "sub1" }

import BoardNavbar from "@/views/business/Navbar.vue";
import Banner from "@/components/Banner.vue";
import { NIcon } from "naive-ui";
import { ChevronForward } from "@vicons/ionicons5";
import { watch } from "vue";
import { USER_ROUTES } from "@/assets/route_constants.ts";
import { useRouter } from "vue-router";
import { useAuth } from "@/composables/useAuth";
import { useAlertDialog } from "@/composables/useAlert";

export default /*@__PURE__*/_defineComponent({
  __name: 'Table',
  setup(__props) {

const useAlert = useAlertDialog();
const { isLoggedIn, isOrgUser } = useAuth();
const router = useRouter();
watch(
  isLoggedIn,
  async (newValue) => {
    if (newValue === false) {
      await useAlert("회원전용 페이지 입니다. 로그인 후 이용해주세요.");
      // TODO : 단순히 뒤로 갈지 향후 확인 후 변경 가능.
      // router.back();
      router.push({ name: USER_ROUTES.Home.Name });
    } else {
      if (isOrgUser.value) {
        await useAlert("개인 사용자만 사용이 가능합니다.");
        router.push({ name: USER_ROUTES.Home.Name });
      }
    }
  },
  { immediate: true }
);

return (_ctx: any,_cache: any) => {
  const _component_n_button = _resolveComponent("n-button")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_unref(isLoggedIn))
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(Banner, {
          title: "",
          subtitle: "",
          description: "학생들과 함께 그들의 미래를 찾는 일을 하고자 합니다. <br>\n        자신의 미래에 관심이 있는 학생 누구에게나 도움을 주고자 합니다."
        }),
        _cache[54] || (_cache[54] = _createStaticVNode("<div class=\"sub_scroll_wrap\" data-v-3a722796><div class=\"width_wrap\" data-v-3a722796><div data-v-3a722796><ul class=\"scroll_nav\" data-v-3a722796></ul></div><i class=\"prev\" data-v-3a722796></i><i class=\"next\" data-v-3a722796></i></div></div>", 1)),
        _createElementVNode("div", _hoisted_2, [
          (!_unref(isOrgUser))
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                _cache[41] || (_cache[41] = _createElementVNode("h1", { class: "sub_subject" }, "[개인] 진단·상담코칭 소요시간· 가격· 구매", -1)),
                _cache[42] || (_cache[42] = _createElementVNode("div", { class: "title_description" }, " 초등학생 ‧ 중학생 ‧ 고등학생 ‧ 대학생 ", -1)),
                _cache[43] || (_cache[43] = _createElementVNode("br", null, null, -1)),
                _cache[44] || (_cache[44] = _createElementVNode("div", null, "◰ 진단검사 및 상담코칭 - 초등학생(✔)", -1)),
                _createElementVNode("div", _hoisted_4, [
                  _createElementVNode("table", _hoisted_5, [
                    _cache[8] || (_cache[8] = _createElementVNode("colgroup", null, [
                      _createElementVNode("col", { style: {"width":"8%"} }),
                      _createElementVNode("col"),
                      _createElementVNode("col", { style: {"width":"14%"} }),
                      _createElementVNode("col", { style: {"width":"14%"} }),
                      _createElementVNode("col", { style: {"width":"14%"} }),
                      _createElementVNode("col", { style: {"width":"14%"} })
                    ], -1)),
                    _cache[9] || (_cache[9] = _createElementVNode("thead", null, [
                      _createElementVNode("tr", null, [
                        _createElementVNode("th", { scope: "col" }, "구분"),
                        _createElementVNode("th", { scope: "col" }, "상품명"),
                        _createElementVNode("th", { scope: "col" }, "문항수"),
                        _createElementVNode("th", { scope: "col" }, "소요시간"),
                        _createElementVNode("th", { scope: "col" }, "가격(원)"),
                        _createElementVNode("th", { scope: "col" }, "검사 구매")
                      ])
                    ], -1)),
                    _createElementVNode("tbody", null, [
                      _createElementVNode("tr", null, [
                        _cache[1] || (_cache[1] = _createElementVNode("td", { rowspan: "3" }, [
                          _createTextVNode("초등학생"),
                          _createElementVNode("br"),
                          _createTextVNode("(고학년)")
                        ], -1)),
                        _cache[2] || (_cache[2] = _createElementVNode("td", { style: {"text-align":"left","padding-left":"20px"} }, " PUTT2.0 다중재능검사_초등학생용(고학년) ", -1)),
                        _cache[3] || (_cache[3] = _createElementVNode("td", { style: {"vertical-align":"top"} }, "128문항", -1)),
                        _cache[4] || (_cache[4] = _createElementVNode("td", null, "40분 내외", -1)),
                        _cache[5] || (_cache[5] = _createElementVNode("td", { rowspan: "3" }, [
                          _createTextVNode("160,000"),
                          _createElementVNode("br"),
                          _createTextVNode("(1인 기준)")
                        ], -1)),
                        _createElementVNode("td", _hoisted_6, [
                          _createVNode(_component_router_link, {
                            to: {
                      name: _unref(USER_ROUTES).Offer.Personal.Name,
                      params: { product_key: '1' },
                    },
                            style: {"display":"inline-flex","align-items":"center"},
                            custom: ""
                          }, {
                            default: _withCtx(({ navigate }) => [
                              _createVNode(_component_n_button, {
                                type: "primary",
                                onClick: navigate,
                                role: "link"
                              }, {
                                default: _withCtx(() => _cache[0] || (_cache[0] = [
                                  _createTextVNode(" 바로 가기 ")
                                ])),
                                _: 2
                              }, 1032, ["onClick"])
                            ]),
                            _: 1
                          }, 8, ["to"])
                        ])
                      ]),
                      _cache[6] || (_cache[6] = _createElementVNode("tr", null, [
                        _createElementVNode("td", { style: {"text-align":"left","padding-left":"20px"} }, " TOCC 창의역량검사_아동용(고학년) "),
                        _createElementVNode("td", { style: {"vertical-align":"top"} }, "80문항"),
                        _createElementVNode("td", null, "30분 내외")
                      ], -1)),
                      _cache[7] || (_cache[7] = _createElementVNode("tr", null, [
                        _createElementVNode("td", { style: {"text-align":"left","padding-left":"20px"} }, " 학습진로 상담코칭_초등학생 "),
                        _createElementVNode("td", { style: {"vertical-align":"top"} }, " "),
                        _createElementVNode("td", null, "40분")
                      ], -1))
                    ])
                  ])
                ]),
                _cache[45] || (_cache[45] = _createElementVNode("br", null, null, -1)),
                _cache[46] || (_cache[46] = _createElementVNode("div", null, "◰ 진단검사 및 상담코칭 - 중학생(✔)", -1)),
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("table", _hoisted_8, [
                    _cache[18] || (_cache[18] = _createElementVNode("colgroup", null, [
                      _createElementVNode("col", { style: {"width":"8%"} }),
                      _createElementVNode("col"),
                      _createElementVNode("col", { style: {"width":"14%"} }),
                      _createElementVNode("col", { style: {"width":"14%"} }),
                      _createElementVNode("col", { style: {"width":"14%"} }),
                      _createElementVNode("col", { style: {"width":"14%"} })
                    ], -1)),
                    _cache[19] || (_cache[19] = _createElementVNode("thead", null, [
                      _createElementVNode("tr", null, [
                        _createElementVNode("th", { scope: "col" }, "구분"),
                        _createElementVNode("th", { scope: "col" }, "상품명"),
                        _createElementVNode("th", { scope: "col" }, "문항수"),
                        _createElementVNode("th", { scope: "col" }, "소요시간"),
                        _createElementVNode("th", { scope: "col" }, "가격(원)"),
                        _createElementVNode("th", { scope: "col" }, "검사 구매")
                      ])
                    ], -1)),
                    _createElementVNode("tbody", null, [
                      _createElementVNode("tr", null, [
                        _cache[11] || (_cache[11] = _createElementVNode("td", { rowspan: "3" }, "중학생", -1)),
                        _cache[12] || (_cache[12] = _createElementVNode("td", { style: {"text-align":"left","padding-left":"20px"} }, " PUTT2.0 다중재능검사_중학생용 ", -1)),
                        _cache[13] || (_cache[13] = _createElementVNode("td", { style: {"vertical-align":"top"} }, "160문항", -1)),
                        _cache[14] || (_cache[14] = _createElementVNode("td", null, "20~30분 내외", -1)),
                        _cache[15] || (_cache[15] = _createElementVNode("td", { rowspan: "3" }, [
                          _createTextVNode("160,000"),
                          _createElementVNode("br"),
                          _createTextVNode("(1인 기준)")
                        ], -1)),
                        _createElementVNode("td", _hoisted_9, [
                          _createVNode(_component_router_link, {
                            to: {
                      name: _unref(USER_ROUTES).Offer.Personal.Name,
                      params: { product_key: '2' },
                    },
                            style: {"display":"inline-flex","align-items":"center"},
                            custom: ""
                          }, {
                            default: _withCtx(({ navigate }) => [
                              _createVNode(_component_n_button, {
                                type: "primary",
                                onClick: navigate,
                                role: "link"
                              }, {
                                default: _withCtx(() => _cache[10] || (_cache[10] = [
                                  _createTextVNode(" 바로 가기 ")
                                ])),
                                _: 2
                              }, 1032, ["onClick"])
                            ]),
                            _: 1
                          }, 8, ["to"])
                        ])
                      ]),
                      _cache[16] || (_cache[16] = _createElementVNode("tr", null, [
                        _createElementVNode("td", { style: {"text-align":"left","padding-left":"20px"} }, " TOCC 창의역량검사_청소년용 "),
                        _createElementVNode("td", { style: {"vertical-align":"top"} }, "80문항"),
                        _createElementVNode("td", null, "20분 내외")
                      ], -1)),
                      _cache[17] || (_cache[17] = _createElementVNode("tr", null, [
                        _createElementVNode("td", { style: {"text-align":"left","padding-left":"20px"} }, " 학습진로 상담코칭_중학생 "),
                        _createElementVNode("td", { style: {"vertical-align":"top"} }, " "),
                        _createElementVNode("td", null, "45분")
                      ], -1))
                    ])
                  ])
                ]),
                _cache[47] || (_cache[47] = _createElementVNode("br", null, null, -1)),
                _cache[48] || (_cache[48] = _createElementVNode("div", null, "◰ 진단검사 및 상담코칭 - 고등학생(✔)", -1)),
                _createElementVNode("div", _hoisted_10, [
                  _createElementVNode("table", _hoisted_11, [
                    _cache[28] || (_cache[28] = _createElementVNode("colgroup", null, [
                      _createElementVNode("col", { style: {"width":"8%"} }),
                      _createElementVNode("col"),
                      _createElementVNode("col", { style: {"width":"14%"} }),
                      _createElementVNode("col", { style: {"width":"14%"} }),
                      _createElementVNode("col", { style: {"width":"14%"} }),
                      _createElementVNode("col", { style: {"width":"14%"} })
                    ], -1)),
                    _cache[29] || (_cache[29] = _createElementVNode("thead", null, [
                      _createElementVNode("tr", null, [
                        _createElementVNode("th", { scope: "col" }, "구분"),
                        _createElementVNode("th", { scope: "col" }, "상품명"),
                        _createElementVNode("th", { scope: "col" }, "문항수"),
                        _createElementVNode("th", { scope: "col" }, "소요시간"),
                        _createElementVNode("th", { scope: "col" }, "가격(원)"),
                        _createElementVNode("th", { scope: "col" }, "검사 구매")
                      ])
                    ], -1)),
                    _createElementVNode("tbody", null, [
                      _createElementVNode("tr", null, [
                        _cache[21] || (_cache[21] = _createElementVNode("td", { rowspan: "3" }, "고등학생", -1)),
                        _cache[22] || (_cache[22] = _createElementVNode("td", { style: {"text-align":"left","padding-left":"20px"} }, " PUTT2.0 다중재능검사_고등학생용 ", -1)),
                        _cache[23] || (_cache[23] = _createElementVNode("td", { style: {"vertical-align":"top"} }, "160문항", -1)),
                        _cache[24] || (_cache[24] = _createElementVNode("td", null, "20~30분 내외", -1)),
                        _cache[25] || (_cache[25] = _createElementVNode("td", { rowspan: "3" }, [
                          _createTextVNode("160,000"),
                          _createElementVNode("br"),
                          _createTextVNode("(1인 기준)")
                        ], -1)),
                        _createElementVNode("td", _hoisted_12, [
                          _createVNode(_component_router_link, {
                            to: {
                      name: _unref(USER_ROUTES).Offer.Personal.Name,
                      params: { product_key: '3' },
                    },
                            style: {"display":"inline-flex","align-items":"center"},
                            custom: ""
                          }, {
                            default: _withCtx(({ navigate }) => [
                              _createVNode(_component_n_button, {
                                type: "primary",
                                onClick: navigate,
                                role: "link"
                              }, {
                                default: _withCtx(() => _cache[20] || (_cache[20] = [
                                  _createTextVNode(" 바로 가기 ")
                                ])),
                                _: 2
                              }, 1032, ["onClick"])
                            ]),
                            _: 1
                          }, 8, ["to"])
                        ])
                      ]),
                      _cache[26] || (_cache[26] = _createElementVNode("tr", null, [
                        _createElementVNode("td", { style: {"text-align":"left","padding-left":"20px"} }, " TOCC 창의역량검사_청소년용 "),
                        _createElementVNode("td", { style: {"vertical-align":"top"} }, "80문항"),
                        _createElementVNode("td", null, "20분 내외")
                      ], -1)),
                      _cache[27] || (_cache[27] = _createElementVNode("tr", null, [
                        _createElementVNode("td", { style: {"text-align":"left","padding-left":"20px"} }, " 학습진로 상담코칭_고등학생 "),
                        _createElementVNode("td", { style: {"vertical-align":"top"} }, " "),
                        _createElementVNode("td", null, "50분")
                      ], -1))
                    ])
                  ])
                ]),
                _cache[49] || (_cache[49] = _createElementVNode("br", null, null, -1)),
                _cache[50] || (_cache[50] = _createElementVNode("div", null, "◰ 진단검사 및 상담코칭 - 대학생‧예비전문가(✔)", -1)),
                _createElementVNode("div", _hoisted_13, [
                  _createElementVNode("table", _hoisted_14, [
                    _cache[38] || (_cache[38] = _createElementVNode("colgroup", null, [
                      _createElementVNode("col", { style: {"width":"8%"} }),
                      _createElementVNode("col"),
                      _createElementVNode("col", { style: {"width":"14%"} }),
                      _createElementVNode("col", { style: {"width":"14%"} }),
                      _createElementVNode("col", { style: {"width":"14%"} }),
                      _createElementVNode("col", { style: {"width":"14%"} })
                    ], -1)),
                    _cache[39] || (_cache[39] = _createElementVNode("thead", null, [
                      _createElementVNode("tr", null, [
                        _createElementVNode("th", { scope: "col" }, "구분"),
                        _createElementVNode("th", { scope: "col" }, "상품명"),
                        _createElementVNode("th", { scope: "col" }, "문항수"),
                        _createElementVNode("th", { scope: "col" }, "소요시간"),
                        _createElementVNode("th", { scope: "col" }, "가격(원)"),
                        _createElementVNode("th", { scope: "col" }, "검사 구매")
                      ])
                    ], -1)),
                    _createElementVNode("tbody", null, [
                      _createElementVNode("tr", null, [
                        _cache[31] || (_cache[31] = _createElementVNode("td", { rowspan: "3" }, [
                          _createTextVNode("대학생‧"),
                          _createElementVNode("br"),
                          _createTextVNode("예비전문가")
                        ], -1)),
                        _cache[32] || (_cache[32] = _createElementVNode("td", { style: {"text-align":"left","padding-left":"20px"} }, " PUTT2.0 다중재능검사_대학생용 ", -1)),
                        _cache[33] || (_cache[33] = _createElementVNode("td", { style: {"vertical-align":"top"} }, "160문항", -1)),
                        _cache[34] || (_cache[34] = _createElementVNode("td", null, "20~30분 내외", -1)),
                        _cache[35] || (_cache[35] = _createElementVNode("td", { rowspan: "3" }, [
                          _createTextVNode("180,000"),
                          _createElementVNode("br"),
                          _createTextVNode("(1인 기준)")
                        ], -1)),
                        _createElementVNode("td", _hoisted_15, [
                          _createVNode(_component_router_link, {
                            to: {
                      name: _unref(USER_ROUTES).Offer.Personal.Name,
                      params: { product_key: '4' },
                    },
                            style: {"display":"inline-flex","align-items":"center"},
                            custom: ""
                          }, {
                            default: _withCtx(({ navigate }) => [
                              _createVNode(_component_n_button, {
                                type: "primary",
                                onClick: navigate,
                                role: "link"
                              }, {
                                default: _withCtx(() => _cache[30] || (_cache[30] = [
                                  _createTextVNode(" 바로 가기 ")
                                ])),
                                _: 2
                              }, 1032, ["onClick"])
                            ]),
                            _: 1
                          }, 8, ["to"])
                        ])
                      ]),
                      _cache[36] || (_cache[36] = _createElementVNode("tr", null, [
                        _createElementVNode("td", { style: {"text-align":"left","padding-left":"20px"} }, " TEC 창의역량검사_전문가용 "),
                        _createElementVNode("td", { style: {"vertical-align":"top"} }, "108문항"),
                        _createElementVNode("td", null, "20~30분 내외")
                      ], -1)),
                      _cache[37] || (_cache[37] = _createElementVNode("tr", null, [
                        _createElementVNode("td", { style: {"text-align":"left","padding-left":"20px"} }, " 학습진로 상담코칭_대학생 "),
                        _createElementVNode("td", { style: {"vertical-align":"top"} }, " "),
                        _createElementVNode("td", null, "50분")
                      ], -1))
                    ])
                  ])
                ]),
                _cache[51] || (_cache[51] = _createElementVNode("br", null, null, -1)),
                _cache[52] || (_cache[52] = _createElementVNode("div", null, "◰ 결제 방법:계좌 이체", -1)),
                _cache[53] || (_cache[53] = _createElementVNode("div", { class: "sub1" }, [
                  _createElementVNode("table", { class: "st_mybd_list" }, [
                    _createElementVNode("colgroup", null, [
                      _createElementVNode("col")
                    ]),
                    _createElementVNode("thead", null, [
                      _createElementVNode("tr", { style: {"background-color":"burlywood"} }, [
                        _createElementVNode("th", { scope: "col" }, " 우리은행 1005-104-783814, (예금주) 주식회사 코코랩 ")
                      ])
                    ])
                  ])
                ], -1)),
                _createElementVNode("div", _hoisted_16, [
                  _createVNode(_component_router_link, {
                    to: `${_unref(USER_ROUTES).Price.Org.Path}`
                  }, {
                    default: _withCtx(() => _cache[40] || (_cache[40] = [
                      _createTextVNode("이 전 ")
                    ])),
                    _: 1
                  }, 8, ["to"])
                ])
              ]))
            : _createCommentVNode("", true)
        ])
      ]))
    : _createCommentVNode("", true)
}
}

})